module.exports = __webpack_public_path__ + "img/price.5d8d4c63.png";